/* Keeps the order-level warning notes ("⚠️ Pre-order", "⚠️ <custom status>")
 * in step with what is actually in the cart.
 *
 * 13 Oct 2026: #15067 (an in-stock All Out Stand) arrived with "⚠️ Pre-order",
 * left on the cart from an earlier pre-order add. Three writers set the note
 * (agpb.js, cart-drawer-extras.js upsell, AG-Preorder-Modal) and nothing ever
 * cleared it; and #15065, a real Black Edition pre-order, arrived without it.
 * This reconciles after every cart change and on page load: a note is added when
 * a line carries the flag and removed when none does. Only notes in the house
 * format ("This order contains one or more ...") are touched, never other
 * attributes. One bounded retry per change; a failure never blocks the cart.
 */
(function () {
  'use strict';
  var PRE_KEY = '⚠️ Pre-order';
  var PRE_VAL = 'This order contains one or more pre-order items. Please check line item details before dispatching.';
  var MARK = 'This order contains one or more ';
  var busy = false, again = false;

  function wanted(cart) {
    var want = {};
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (String(p._preorder || '').toLowerCase() === 'true') want[PRE_KEY] = PRE_VAL;
      if (p._custom_status) {
        var label = String(p._custom_status);
        want['⚠️ ' + label] = MARK + label + ' items. Please check line item details before dispatching.';
      }
    });
    return want;
  }

  function diff(cart) {
    var have = cart.attributes || {}, want = wanted(cart), patch = {}, n = 0;
    Object.keys(want).forEach(function (k) { if (have[k] !== want[k]) { patch[k] = want[k]; n++; } });
    Object.keys(have).forEach(function (k) {
      if (want[k] === undefined && String(have[k] || '').indexOf(MARK) === 0) { patch[k] = ''; n++; } // '' removes it
    });
    return n ? patch : null;
  }

  function post(patch, tries) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: patch }),
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
    }).catch(function () {
      if (tries > 0) return post(patch, tries - 1);
    });
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js?_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (cart) { var patch = diff(cart); return patch ? post(patch, 1) : null; })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; setTimeout(sync, 300); }
      });
  }

  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(sync, 400); }

  ['on:cart:add', 'on:cart:change', 'on:cart:remove', 'on:cart:after-merge', 'cart:refresh', 'cart:updated', 'agcd:upsell-added']
    .forEach(function (ev) { document.addEventListener(ev, soon); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon); else soon();
})();
